import { Component, computed, effect, inject, input, OnInit, output, signal, ViewChild } from '@angular/core';
import { CoreModule, FormComponent, OffersType } from '@toevla-webapplications/core';
import { BookingDetailsComponent } from './components/booking-details/booking-details.component';
import { BookingFirstCampComponent } from './components/booking-first-camp/booking-first-camp.component';
import { BookingInfoComponent } from './components/booking-info/booking-info.component';
import { BookingOhContactsComponent } from './components/booking-oh-contacts/booking-oh-contacts.component';
import { BookingOhDetailsComponent } from './components/booking-oh-details/booking-oh-details.component';
import { BookingOtherCampsComponent } from './components/booking-other-camps/booking-other-camps.component';
import { TranslateModule } from '@ngx-translate/core';
import { BookingService } from '../../../../services/booking/booking.service';
import { ToastsService } from '../../../../services/toasts/toasts.service';
import { Offer } from '../../../../services/offers/offer.model';

@Component({
    selector: 'ivva-form-booking',
    templateUrl: './form-booking.component.html',
    styleUrls: ['./form-booking.component.scss'],
    imports: [
        BookingDetailsComponent,
        BookingFirstCampComponent,
        BookingInfoComponent,
        BookingOhContactsComponent,
        BookingOhDetailsComponent,
        BookingOtherCampsComponent,
        CoreModule,
        TranslateModule,
    ]
})
export class FormBookingComponent implements OnInit {
	@ViewChild('stepComponent')
	stepComponent: FormComponent;

	offer = input<Offer>();
	submitted = output();

	currentStep = signal(1);
	loadingSubmit = signal(false);

	stepName = computed(() => {
		const offer = this.offer();
		const step = this.currentStep();

		switch (offer?.type) {
			case OffersType.ORGANIZED_HOLIDAY:
				return `BOOKING.OH_STEP_${step}`;
			case OffersType.ACCOMMODATION:
				return `BOOKING.STEP_${step}_ACCOMMODATION`;
		}

		return `BOOKING.STEP_${step}`;
	});
	totalSteps = computed(() => {
		const offer = this.offer();
		return offer?.type === OffersType.ORGANIZED_HOLIDAY ? 4 : 2;
	});

	readonly OffersType = OffersType;

	readonly #bookingService = inject(BookingService);
	readonly #toastsService = inject(ToastsService);

	constructor() {
		effect(() => {
			this.currentStep();
			this.scrollToTop();
		});
	}

	ngOnInit() {
		const offer = this.offer();

		if (offer) {
			this.#bookingService.new(offer, false);
		}
	}

	prev() {
		this.save();
		this.currentStep.update((step) => step - 1);
	}

	next() {
		if (this.save()) {
			this.currentStep.update((step) => step + 1);
		}
	}

	submit() {
		if (!this.loadingSubmit() && this.save()) {
			this.loadingSubmit.set(true);

			this.#bookingService.submit().subscribe({
				next: () => {
					this.loadingSubmit.set(false);
					this.submitted.emit();
				},
				error: (res) => {
					this.#toastsService.serverError(res);
					this.loadingSubmit.set(false);
				},
			});
		}
	}

	private save(): boolean {
		const data = this.stepComponent.getFormData();
		this.#bookingService.update(data);

		return this.stepComponent.isFormValid();
	}

	private scrollToTop() {
		window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
	}
}
